import {Card, CardActionArea, CardContent, Divider, Grid, Typography} from "@mui/material";
import {VesselCallShort} from "~/queries";
import {formatDate} from "~/apps/core/utils";
import moment from "moment";
import {TypographyWithIcon} from "~/apps/core/ui/TypographyWithIcon";
import {TypographyWithLabel} from "~/apps/core/ui/TypographyWithLabel";
import {NavigateNext, Star} from "@mui/icons-material";
import React from "react";
import {StatusBadge} from "~/apps/core/ui/StatusBadge";
import {getVesselCallStatusColor} from "~/apps/packages/vessel-calls/utils";
import {Tag} from "~/apps/core/ui/Tag";
import {BorderedBox} from "~/apps/core/ui/BorderedBox";
import {useHistory} from "react-router-dom";


export type VesselCallItemProps = {
    vesselCall: VesselCallShort
}

export const VesselCallItem = React.memo<VesselCallItemProps>((props: VesselCallItemProps) => {
    const {vesselCall} = props;
    const history = useHistory();

    const tags = [...new Set([
        vesselCall.type, vesselCall.arrival.type, vesselCall.departure.type
    ].filter(Boolean))];

    const handleClick = () => {
        history.push(`/${vesselCall.id}`);
    }

    return (
        <Card style={{width: "100%"}}>
            <CardActionArea onClick={handleClick}>
                <CardContent>
                    <Grid container direction="column" rowSpacing="8px" wrap="nowrap">
                        <Grid item container direction="column" rowSpacing="4px">
                            <Grid container direction="row" justifyContent="space-between">
                                <Grid item>
                                    <StatusBadge variant="cardText" outlined={false} badgeColor={getVesselCallStatusColor(vesselCall.status)}>
                                        {vesselCall.status}
                                    </StatusBadge>
                                </Grid>
                                <Grid item>
                                    <Grid container alignItems="center" spacing="4px">
                                        {vesselCall.favorite && (
                                            <Grid item>
                                                <Star style={{color:"#E8B042", fontSize: "13px"}}/>
                                            </Grid>
                                        )}
                                        {vesselCall.vessel.imo && (
                                            <Grid item>
                                                <BorderedBox variant="cardText">
                                                            <span>
                                                                IMO {vesselCall.vessel.imo}
                                                            </span>
                                                </BorderedBox>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item>
                                <Typography variant="cardTitle2" color="#232326">
                                    {vesselCall.vessel.name}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid item container direction="row" spacing="8px">
                            {tags.map(tag => (
                                <Grid item key={tag}>
                                    <Tag>
                                        {tag}
                                    </Tag>
                                </Grid>
                            ))}
                        </Grid>
                        <Grid item>
                            <Divider/>
                        </Grid>
                        <Grid item container direction="row" columnSpacing="16px" rowSpacing="8px" flexWrap="wrap">
                            <Grid item>
                               <TypographyWithLabel label="Прибытие">
                                   {vesselCall.arrival.date && (
                                       formatDate(moment(vesselCall.arrival.date, "YYYY-MM-DD"))
                                   )}
                               </TypographyWithLabel>
                            </Grid>
                            <Grid item>
                                <TypographyWithLabel label="Убытие">
                                    {vesselCall.departure.date && (
                                        formatDate(moment(vesselCall.departure.date, "YYYY-MM-DD"))
                                    )}
                                </TypographyWithLabel>
                            </Grid>
                            <Grid item alignSelf="flex-end" flexGrow="1" textAlign="right">
                                <TypographyWithIcon endIcon={<NavigateNext/>} color="textSecondary" variant="cardText" marginRight="-8px" marginBottom="-2px">
                                    Подробнее
                                </TypographyWithIcon>
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </CardActionArea>
        </Card>
    )
});